// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documents-page .documents-period {
  margin-bottom: 8px;
}
.documents-page .documents-period > summary {
  color: #78849a;
  font-size: 12px;
}
.documents-page .documents-period > summary > span {
  display: flex;
  align-items: center;
  gap: 8px;
}
.documents-page .documents-period > summary > span > svg {
  width: 16px;
  height: 16px;
}
.documents-page .documents-period > summary > span b {
  padding: 3px 6px;
  border-radius: 5px;
  background: #e9edf4;
  font-size: 10px;
  font-weight: 500;
}
.documents-page .documents-period fieldset {
  margin: 0 0 10px;
}
.documents-page .documents-categories {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  margin: 0 0 10px;
  padding-bottom: 3px;
  scrollbar-width: thin;
}
.documents-page .documents-categories button {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  max-width: 240px;
  padding: 8px 12px;
  border: 1px solid #e1e6ef;
  border-radius: 10px;
  background: white;
  color: #6f7b92;
  font-size: 12px;
}
.documents-page .documents-categories button span {
  font-size: 10px;
}
.documents-page .documents-categories button[aria-pressed=true] {
  color: #e72f44;
  background: #fff1f4;
  border-color: #f4d6dc;
}
.documents-page .documents-count {
  margin-bottom: 8px;
  min-height: 28px;
}
.documents-page .documents-list {
  display: grid;
  gap: 8px;
}
.documents-page .documents-row {
  margin-bottom: 0;
  padding-block: 10px;
}
.documents-page .documents-file {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.documents-page .documents-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  border: none;
  background: none;
  color: #232137;
  text-align: left;
  text-decoration: none;
  min-height: 56px;
  padding: 0;
}
.documents-page .documents-file-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  flex: 0 0 36px;
  height: 44px;
  border-radius: 9px;
  background: #eef2fa;
  color: #6e7b98;
}
.documents-page .documents-file-icon > svg {
  width: 20px;
  height: 20px;
}
.documents-page .documents-file-icon small {
  font-size: 8px;
}
.documents-page .documents-file-info {
  flex: 1 1;
  min-width: 0;
  display: grid;
  gap: 5px;
}
.documents-page .documents-file-info strong {
  font-size: 13px;
  line-height: 1.4;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.documents-page .documents-file-info small {
  font-size: 10px;
  line-height: 1.5;
  color: #78849a;
}
.documents-page .documents-row .compact-icon-button {
  border: none;
}
.documents-page .documents-comment-short {
  margin: 6px 0 0;
  color: #78849a;
  font-size: 11px;
  overflow-wrap: anywhere;
}
.documents-page .documents-comment {
  border-top: 1px solid #edf0f5;
  margin-top: 8px;
}
.documents-page .documents-comment summary {
  font-size: 11px;
  color: #78849a;
}
.documents-page .documents-comment p {
  overflow-wrap: anywhere;
}
@media (max-width: 350px) {
  .documents-page .documents-period fieldset {
    grid-template-columns: minmax(0, 1fr);
  }
}

.document-viewer .lkfr-dialog-heading h2 {
  font-size: 16px;
  overflow-wrap: anywhere;
}
.document-viewer > p {
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.document-viewer .document-preview {
  height: min(58vh, 600px);
  width: 100%;
  border: 1px solid #e1e6ef;
  border-radius: 10px;
}
.document-viewer .document-preview-image {
  display: block;
  width: 100%;
  max-height: 60vh;
  object-fit: contain;
  margin-bottom: 10px;
}
.document-viewer > a {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/DocumentsPage/documentsCompact.scss"],"names":[],"mappings":"AACE;EAAoB,kBAAA;AACtB;AAD0C;EAAY,cAAA;EAAgB,eAAA;AAKtE;AALuF;EAAS,aAAA;EAAe,mBAAA;EAAqB,QAAA;AAUpI;AAV8I;EAAQ,WAAA;EAAa,YAAA;AAcnK;AAdmL;EAAI,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;AAqBnQ;AArB2R;EAAW,gBAAA;AAwBtS;AAvBE;EAAwB,aAAA;EAAe,QAAA;EAAU,gBAAA;EAAkB,gBAAA;EAAkB,mBAAA;EAAqB,qBAAA;AA+B5G;AA9BI;EAAS,cAAA;EAAgB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,gBAAA;EAAkB,iBAAA;EAAmB,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,eAAA;AA4C5N;AA5C6O;EAAO,eAAA;AA+CpP;AA/CuQ;EAAuB,cAAA;EAAgB,mBAAA;EAAqB,qBAAA;AAoDnU;AAlDE;EAAmB,kBAAA;EAAoB,gBAAA;AAsDzC;AArDE;EAAkB,aAAA;EAAe,QAAA;AAyDnC;AAxDE;EAAiB,gBAAA;EAAkB,mBAAA;AA4DrC;AA3DE;EAAkB,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,YAAA;AAiElE;AAhEE;EAAkB,SAAA;EAAS,YAAA;EAAc,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,YAAA;EAAc,gBAAA;EAAkB,cAAA;EAAgB,gBAAA;EAAkB,qBAAA;EAAuB,gBAAA;EAAkB,UAAA;AA8ErM;AA7EE;EAAuB,aAAA;EAAe,sBAAA;EAAwB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,cAAA;EAAgB,YAAA;EAAc,kBAAA;EAAoB,mBAAA;EAAqB,cAAA;AAyF/L;AAzF+M;EAAQ,WAAA;EAAa,YAAA;AA6FpO;AA7FoP;EAAQ,cAAA;AAgG5P;AA/FE;EAAuB,SAAA;EAAS,YAAA;EAAc,aAAA;EAAe,QAAA;AAqG/D;AArGyE;EAAS,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;EAAyB,oBAAA;EAAsB,qBAAA;EAAuB,4BAAA;EAA8B,gBAAA;AA8GzN;AA9G6O;EAAQ,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAmHxR;AAlHE;EAAsC,YAAA;AAqHxC;AApHE;EAA2B,eAAA;EAAiB,cAAA;EAAgB,eAAA;EAAiB,uBAAA;AA0H/E;AAzHE;EAAqB,6BAAA;EAA+B,eAAA;AA6HtD;AA7HuE;EAAU,eAAA;EAAiB,cAAA;AAiIlG;AAjIoH;EAAI,uBAAA;AAoIxH;AAnIE;EAA4B;IAA6B,qCAAA;EAuIzD;AACF;;AAtImB;EAA0B,eAAA;EAAiB,uBAAA;AA2I9D;AA3IyF;EAAM,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;AAgJlI;AAhJ6J;EAAoB,wBAAA;EAA0B,WAAA;EAAa,yBAAA;EAA2B,mBAAA;AAsJnP;AAtJ0Q;EAA0B,cAAA;EAAgB,WAAA;EAAa,gBAAA;EAAkB,mBAAA;EAAqB,mBAAA;AA6JxW;AA7J+X;EAAM,gBAAA;AAgKrY","sourcesContent":[".documents-page {\n  .documents-period { margin-bottom: 8px; > summary { color: #78849a; font-size: 12px; > span { display: flex; align-items: center; gap: 8px; > svg { width: 16px; height: 16px; } b { padding: 3px 6px; border-radius: 5px; background: #e9edf4; font-size: 10px; font-weight: 500; } } } fieldset { margin: 0 0 10px; } }\n  .documents-categories { display: flex; gap: 6px; overflow-x: auto; margin: 0 0 10px; padding-bottom: 3px; scrollbar-width: thin;\n    button { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 6px; min-height: 44px; max-width: 240px; padding: 8px 12px; border: 1px solid #e1e6ef; border-radius: 10px; background: white; color: #6f7b92; font-size: 12px; span { font-size: 10px; } &[aria-pressed=true] { color: #e72f44; background: #fff1f4; border-color: #f4d6dc; } }\n  }\n  .documents-count { margin-bottom: 8px; min-height: 28px; }\n  .documents-list { display: grid; gap: 8px; }\n  .documents-row { margin-bottom: 0; padding-block: 10px; }\n  .documents-file { display: flex; align-items: center; gap: 6px; min-width: 0; }\n  .documents-main { flex: 1; min-width: 0; display: flex; align-items: center; gap: 10px; border: none; background: none; color: #232137; text-align: left; text-decoration: none; min-height: 56px; padding: 0; }\n  .documents-file-icon { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; flex: 0 0 36px; height: 44px; border-radius: 9px; background: #eef2fa; color: #6e7b98; > svg { width: 20px; height: 20px; } small { font-size: 8px; } }\n  .documents-file-info { flex: 1; min-width: 0; display: grid; gap: 5px; strong { font-size: 13px; line-height: 1.4; overflow-wrap: anywhere; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; } small { font-size: 10px; line-height: 1.5; color: #78849a; } }\n  .documents-row .compact-icon-button { border: none; }\n  .documents-comment-short { margin: 6px 0 0; color: #78849a; font-size: 11px; overflow-wrap: anywhere; }\n  .documents-comment { border-top: 1px solid #edf0f5; margin-top: 8px; summary { font-size: 11px; color: #78849a; } p { overflow-wrap: anywhere; } }\n  @media (max-width: 350px) { .documents-period fieldset { grid-template-columns: minmax(0, 1fr); } }\n}\n.document-viewer { .lkfr-dialog-heading h2 { font-size: 16px; overflow-wrap: anywhere; } > p { font-size: 12px; line-height: 1.5; overflow-wrap: anywhere; } .document-preview { height: min(58vh, 600px); width: 100%; border: 1px solid #e1e6ef; border-radius: 10px; } .document-preview-image { display: block; width: 100%; max-height: 60vh; object-fit: contain; margin-bottom: 10px; } > a { margin-top: 10px; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
